// Capsule Corp artwork — replace these URLs to swap the art
export const CAPSULE_IMAGE = "https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/a4qtdxmu_1773124855771.webp";
export const CAPSULE_CORP_LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/9a8d56fbe9a144c2_image.png";

export const HoiPoiCapsule = ({ className = '' }) => (
  <img src={CAPSULE_IMAGE} alt="" aria-hidden="true" draggable={false} className={className} />
);

export const CapsuleCorpLogo = () => (
  <img src={CAPSULE_CORP_LOGO} alt="Capsule Corp." draggable={false} />
);

export const SmokePuffArt = ({ id }) => (
  <svg viewBox="0 0 100 100" aria-hidden="true">
    <defs>
      <clipPath id={`cc-puff-clip-${id}`}>
        <circle cx="50" cy="50" r="44" />
      </clipPath>
    </defs>
    <circle cx="50" cy="50" r="44" fill="#fff" />
    <g clipPath={`url(#cc-puff-clip-${id})`}>
      <circle cx="64" cy="66" r="40" fill="#dfe6f3" />
      <circle cx="58" cy="60" r="36" fill="#fff" />
    </g>
    <circle cx="50" cy="50" r="44" fill="none" stroke="#0f1730" strokeWidth="5" />
    <path d="M30 34 q8 -10 20 -10" stroke="#0f1730" strokeWidth="3" fill="none" strokeLinecap="round" opacity=".35" />
  </svg>
);
